import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=bb028ade&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb028ade')) {
      api.createRecord('bb028ade', component.options)
    } else {
      api.reload('bb028ade', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=bb028ade&", function () {
      api.rerender('bb028ade', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2f0pnJQiuDB5k/JS/comp/ImgFallback.vue"
export default component.exports